export default function (date: string): string {
	return date ? new Date(date).toLocaleDateString() : '-';
}
